import { validateWeight } from '../../../common/helpers/weight-uom-validate';
import { validateVolume } from '../../../common/helpers/volume-uom-validate';
import { EmeraldError } from 'src/common/api/emerald-error';
import { popupMessage } from 'src/messages/business-logic/popup-message';

const INCONSISTENT_ITEM_UOM_CODE = 'ItemError_UomInconsistency';

export const validateItemQuantityByUom = (
  quantity?: number,
  unitOfMeasure?: string,
  isManualWeight?: boolean,
): void => {
  const isItemWeightValid: boolean = validateWeight(unitOfMeasure);
  const isItemVolumeValid: boolean = validateVolume(unitOfMeasure);
  // when volume is measured, quantity cannot be greater than 1
  if (isItemVolumeValid && quantity && quantity > 1) {
    throw new EmeraldError(
      'IllegalQuantityOnVolumeItem',
      'Illegal input of quantity for volume item',
    );
  }
  if (!isItemWeightValid && !isItemVolumeValid && isManualWeight) {
    throw new EmeraldError(INCONSISTENT_ITEM_UOM_CODE);
  }
};

export const isValidQuantity = (
  metricValue: number,
  unitOfMeasure?: string,
  isManualWeight?: boolean,
): boolean => {
  let validInput = true;
  try {
    validateItemQuantityByUom(metricValue, unitOfMeasure, isManualWeight);
    if (validateWeight(unitOfMeasure) && !isManualWeight && metricValue > 1) {
      throw new EmeraldError('ItemError_QuantityNotAllowedForWeighable');
    }
  } catch (err) {
    popupMessage(err);
    validInput = false;
  }
  return validInput;
};
